import { createSlice } from '@reduxjs/toolkit'
import { getTableReservationConfigurationACTION, InsertUpdateTableReservationACTION, ValidateOtpReservationACTION, ResendOtpReservationACTION, GetAllTableReservationACTION, GetTableReservationACTION } from '../actions/tableReservation.Actions'

const INITIAL_STATE = {
    tableConfiguration: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    insertUpdateTableRes: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    validateOtpReservation: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    resendOtpReservation: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    getAllReservation: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    getReservationDetail: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    }
};

const tableReservationReducer = createSlice({
    name: 'TableReservation',
    initialState: INITIAL_STATE,
    reducers: {
        ResetTableReservationStates(state, action) {
            state.insertUpdateTableRes = INITIAL_STATE.insertUpdateTableRes;
            state.validateOtpReservation = INITIAL_STATE.validateOtpReservation;
        },
        ResetInsertUpdateTableReservation(state, action) {
            state.insertUpdateTableRes = INITIAL_STATE.insertUpdateTableRes;
        },
        ResetValidateOtpTableReservation(state, action) {
            state.validateOtpReservation = INITIAL_STATE.validateOtpReservation;
        },
    },
    extraReducers: (builder) => {
        //------------------------------- getWebConfigurationACTION start -------------------------
        // eslint-disable-next-line
        builder.addCase(getTableReservationConfigurationACTION.fulfilled, (state, action) => {
            //console.log("getWebConfigurationACTION", action);
            state.tableConfiguration.data = action.payload.data;
            state.tableConfiguration.apiMsg.status = action.meta.requestStatus;
            state.tableConfiguration.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getTableReservationConfigurationACTION.pending, (state, action) => {
            //console.log("getWebConfigurationACTION pending", action);
            state.tableConfiguration.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getTableReservationConfigurationACTION.rejected, (state, action) => {
            //console.log("getWebConfigurationACTION rejected", action);
            state.tableConfiguration.apiMsg.message = action.error.message;
            state.tableConfiguration.apiMsg.status = action.meta.requestStatus;
        });
        //------------------------------- getWebConfigurationACTION end -------------------------
        //------------------------------- InsertUpdateTableReservationACTION start -------------------------
        // eslint-disable-next-line
        builder.addCase(InsertUpdateTableReservationACTION.fulfilled, (state, action) => {
            //console.log("getWebConfigurationACTION", action);
            state.insertUpdateTableRes.data = action.payload.data;
            state.insertUpdateTableRes.apiMsg.status = action.meta.requestStatus;
            state.insertUpdateTableRes.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(InsertUpdateTableReservationACTION.pending, (state, action) => {
            //console.log("getWebConfigurationACTION pending", action);
            state.insertUpdateTableRes.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(InsertUpdateTableReservationACTION.rejected, (state, action) => {
            //console.log("getWebConfigurationACTION rejected", action);
            state.insertUpdateTableRes.apiMsg.message = action.error.message;
            state.insertUpdateTableRes.apiMsg.status = action.meta.requestStatus;
        });
        //------------------------------- getWebConfigurationACTION end -------------------------


        builder.addCase(ValidateOtpReservationACTION.fulfilled, (state, action) => {
            //console.log("ValidateOtpReservationACTION", action);
            state.validateOtpReservation.data = action.payload.data;
            state.validateOtpReservation.apiMsg.status = action.meta.requestStatus;
            state.validateOtpReservation.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(ValidateOtpReservationACTION.pending, (state, action) => {
            //console.log("ValidateOtpReservationACTION pending", action);
            state.validateOtpReservation.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(ValidateOtpReservationACTION.rejected, (state, action) => {
            //console.log("ValidateOtpReservationACTION rejected", action);
            state.validateOtpReservation.apiMsg.message = action.error.message;
            state.validateOtpReservation.apiMsg.status = action.meta.requestStatus;
        });



        builder.addCase(ResendOtpReservationACTION.fulfilled, (state, action) => {
            //console.log("resendOtpReservation", action);
            state.resendOtpReservation.data = action.payload.data;
            state.resendOtpReservation.apiMsg.status = action.meta.requestStatus;
            state.resendOtpReservation.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(ResendOtpReservationACTION.pending, (state, action) => {
            //console.log("resendOtpReservation pending", action);
            state.resendOtpReservation.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(ResendOtpReservationACTION.rejected, (state, action) => {
            //console.log("resendOtpReservation rejected", action);
            state.resendOtpReservation.apiMsg.message = action.error.message;
            state.resendOtpReservation.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(GetAllTableReservationACTION.fulfilled, (state, action) => {
            //console.log("getAllReservation", action);
            state.getAllReservation.data = action.payload.data;
            state.getAllReservation.apiMsg.status = action.meta.requestStatus;
            state.getAllReservation.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(GetAllTableReservationACTION.pending, (state, action) => {
            //console.log("getAllReservation pending", action);
            state.getAllReservation.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(GetAllTableReservationACTION.rejected, (state, action) => {
            //console.log("getAllReservation rejected", action);
            state.getAllReservation.apiMsg.message = action.error.message;
            state.getAllReservation.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(GetTableReservationACTION.fulfilled, (state, action) => {
            //console.log("getReservationDetail", action);
            state.getReservationDetail.data = action.payload.data;
            state.getReservationDetail.apiMsg.status = action.meta.requestStatus;
            state.getReservationDetail.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(GetTableReservationACTION.pending, (state, action) => {
            //console.log("getReservationDetail pending", action);
            state.getReservationDetail.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(GetTableReservationACTION.rejected, (state, action) => {
            //console.log("getReservationDetail rejected", action);
            state.getReservationDetail.apiMsg.message = action.error.message;
            state.getReservationDetail.apiMsg.status = action.meta.requestStatus;
        });
    }
})

export const { ResetInsertUpdateTableReservation, ResetValidateOtpTableReservation, ResetTableReservationStates } = tableReservationReducer.actions;
export default tableReservationReducer.reducer;